import { Component } from 'react';

import * as ReactDOM from 'react-dom';

import { isBottomVisible } from './ScrollHelper';

class ScrollPanel extends Component {
    componentDidMount() {
        // eslint-disable-next-line react/no-find-dom-node
        const elementTarget = ReactDOM.findDOMNode(this);
        this.handleVisibleBottomCheck(elementTarget);
    }

    onScroll = (event) => {
        this.handleVisibleBottomCheck(event.target);
    };

    handleVisibleBottomCheck = (elementTarget) => {
        const { enabled } = this.props;

        if (enabled && isBottomVisible(elementTarget)) {
            this.props.onBottomVisible();
        }
    };

    render() {
        const { children, type: NodeType, ...otherProps } = this.props;

        return (
            <NodeType onScroll={this.onScroll} {...otherProps}>
                {children}
            </NodeType>
        );
    }
}

export { ScrollPanel };
